import React, { Component } from 'react';
import Slider from 'react-rangeslider'
import 'react-rangeslider/lib/index.css'
import { getTranslation } from '../Utilities/GetTranslation';

class NamezzzSlider extends Component {
    constructor(props) {
        super(props);
        this.handleValueChange = this.handleValueChange.bind(this);
    }

    handleValueChange(id, e) {
        this.props.onChange(id, e);
    }

    handleDelete(id, e) {
        e.preventDefault();
        this.props.onDelete(id);
    }

    render() {
        const labels = {
            1:1,    
            2:2,
            3:3,
            4:4,
            5:5,
            6:6,
            7:7,
            8:8,
            9:9,
        };

        return (
            <li>
                <div className="col-md-4">{this.props.text}</div>
                <div className="col-md-8">
                    <Slider max={9} value={this.props.value} labels={labels} onChange={(e) => this.handleValueChange(this.props.id, e)} />
                    {
                        (this.props.delete) ?
                            <a href="# " onClick={(e) => this.handleDelete(this.props.id, e)}><span className="sr-only">{getTranslation("sns.general.screenreader.delete")}</span><i className="fa fa-trash-o" aria-hidden="true"></i></a> :
                            ""
                    }                    
                </div>

            </li>
        );
    }
}

export default NamezzzSlider;


// WEBPACK FOOTER //
// ./src/Fields/NamezzzSlider.js